export const toDateTimeLocal = (value?: Date | string): string => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const timezoneOffset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - timezoneOffset).toISOString().slice(0, 16);
};

export const toCommunicationDateISOString = (value: string): string =>
  new Date(value).toISOString();

export const getCommunicationPeriodError = (startDate: string, endDate: string): string | null => {
  if (!startDate || !endDate) {
    return 'Informe a data de início e a data de término!';
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return 'Data de início ou término inválida!';
  }

  if (end <= start) {
    return 'A data de término deve ser posterior à data de início!';
  }

  return null;
};
